
// Example body:
// {
//   "page": 1,
//   "limit": 5,
//   "filters": {
//       "and": [
//           ["product.brand_id", "=", "1"]
//       ]
//   }
// }

export interface FilterInput {
  page: number;
  limit: number;
  filters: FilterParameters;
}

export interface FilterParameters {
  and?: Array<Array<any>>;
  or?: Array<Array<any>>;
}

export interface CreateMediaBannerPayload {
  banner_type: string;
  banner_value: number;
  translations: BannerTranslationInput[];
}
export interface BannerTranslationInput {
  language: 'en-us' | 'ar-ae';
  view_type: ViewTypeInput;
}
export interface ViewTypeInput {
  mobile: ViewImageInput;
  desktop: ViewImageInput;
}
export interface ViewImageInput {
  image_url: string;
}
